import { AuthPayload } from "@saif-reporting/domain/dtos/AuthPayload.js";

export const useAuthStore = defineStore("auth", () => {
  const authCookie = useCookie<AuthPayload | null>("auth", {
    default() {
      return null;
    },
  });

  const user = computed<AuthPayload | null>(() => {
    return authCookie.value ? AuthPayload.create({ ...authCookie.value }) : null;
  });

  function setAuthCookie(payload: AuthPayload | null) {
    if (payload == null) {
      authCookie.value = null;
    } else {
      authCookie.value = AuthPayload.create({ ...payload });
    }
  }

  return {
    user,
    authCookie,
    setAuthCookie,
  };
});
